{
  "shell.accountMenu.admin": "Admin",
  "shell.accountMenu.customizeDashboard": "Customize dashboard",
  "shell.accountMenu.open": "Account menu",
  "shell.accountMenu.profile": "Profile",
  "shell.accountMenu.settings": "Settings",
  "shell.accountMenu.signOut": "Sign out",
  "shell.actionNotification.done": "Done",
  "shell.actionNotification.goTo": "Go to",
  "shell.app.addApp": "Add app",
  "shell.app.agents": "Agents",
  "shell.app.analytics": "Analytics",
  "shell.app.announcements": "Announcements",
  "shell.app.calendar": "Calendar",
  "shell.app.chat": "Team chat",
  "shell.app.company": "Company",
  "shell.app.data": "Data",
  "shell.app.files": "Files",
  "shell.app.home": "Home",
  "shell.app.inbox": "Inbox",
  "shell.app.people": "People",
  "shell.comm.brand": "Symbols Chat",
  "shell.comm.askAi": "Ask AI",
  "shell.app.mail": "Mail",
  "shell.app.marketplace": "Marketplace",
  "shell.app.meet": "Meet",
  "shell.app.more": "More",
  "shell.app.myProfile": "My profile",
  "shell.app.notes": "Notes",
  "shell.app.reminders": "Reminders",
  "shell.app.history": "History",
  "shell.app.studio": "Apps",
  "shell.app.tasks": "Tasks",
  "shell.app.team": "Team",
  "shell.app.teamAndAgents": "Team & agents",
  "shell.app.teamMembers": "Team members",
  "shell.app.terminal": "Terminal",
  "shell.app.workspace": "Workspace",
  "shell.assistantToggle.ariaLabel": "Toggle AI Assistant",
  "shell.assistantToggle.tooltip": "AI Assistant",
  "shell.clipboard.pasteFailed.title": "Can not paste",
  "shell.commandPalette.error": "Error: {error}",
  "shell.commandPalette.inputAria": "Canvas command or search",
  "shell.commandPalette.placeholder": "Type / for command, or search",
  "shell.commandPalette.ran": "Ran /{name}",
  "shell.commandPalette.unknown": "Unknown: /{name}",
  "shell.comments.cancelReply": "Cancel reply",
  "shell.comments.edited": "edited",
  "shell.comments.empty": "No comments yet.",
  "shell.comments.error": "Comments could not be loaded.",
  "shell.comments.loading": "Loading comments…",
  "shell.comments.placeholder": "Write a comment…",
  "shell.comments.post": "Post",
  "shell.comments.remove": "Delete",
  "shell.comments.removed": "Comment deleted",
  "shell.comments.reply": "Reply",
  "shell.comments.replyingTo": "Replying to {name}",
  "shell.comments.title": "Comments",
  "shell.comments.unknown": "Unknown",
  "shell.comments.postError": "Your comment was not posted. Nothing was lost — try again.",
  "shell.comments.removeError": "The comment could not be deleted.",
  "shell.errorState.forbidden.heading": "You don't have access",
  "shell.errorState.forbidden.hint": "Ask an admin to grant the right permission.",
  "shell.errorState.generic.heading": "Couldn't load",
  "shell.errorState.generic.hint": "Refresh the page to try again.",
  "shell.errorState.lazyPage": "Couldn’t load this page. Refresh to try again.",
  "shell.errorState.notFound.heading": "Not found",
  "shell.errorState.notFound.hint": "The page you're looking for doesn't exist.",
  "shell.errorState.offline.heading": "You're offline",
  "shell.errorState.offline.hint": "Reconnect to the internet to load this page.",
  "shell.errorState.serverError.heading": "Something went wrong",
  "shell.errorState.serverError.hint": "A server error broke the page. Try again in a moment.",
  "shell.header.logo.ariaLabel": "Symbols home",
  "shell.header.mail.tooltip": "Mail",
  "shell.header.newCall.tooltip": "Start a call",
  "shell.headerSearch.close": "Close search",
  "shell.headerSearch.loading": "Searching…",
  "shell.headerSearch.noResults": "No results for “{query}”",
  "shell.headerSearch.openDropdown": "Open search dropdown",
  "shell.headerSearch.placeholder": "Search across everything…",
  "shell.headerTabs.apps": "Apps",
  "shell.headerTabs.dashboard": "Dashboard",
  "shell.headerTabs.dashboardAriaLabel": "Go to dashboard",
  "shell.headerTabs.openApps": "Open apps",
  "shell.headerTabs.openWorkspace": "Open workspace",
  "shell.headerTabs.primaryNav": "Primary",
  "shell.launcher.adminConsole.caption": "Workspace administration",
  "shell.launcher.adminConsole.title": "Admin console",
  "shell.launcher.adminLogs.caption": "Administrative activity trail",
  "shell.launcher.adminLogs.title": "Admin logs",
  "shell.launcher.agents.caption": "All agents — filter by yours, status, type or assignment",
  "shell.launcher.agents.title": "Agents",
  "shell.launcher.analytics.caption": "Full traction on what you're building",
  "shell.launcher.analytics.title": "Analytics",
  "shell.launcher.appStore": "App Store",
  "shell.launcher.appStoreTooltip": "Browse the App Store",
  "shell.launcher.filterPlaceholder": "Filter apps and results",
  "shell.launcher.history.caption": "Everyone's activity on one timeline",
  "shell.launcher.history.title": "Workspace History",
  "shell.launcher.broadcast.caption": "Announcements, polls and the workspace feed",
  "shell.launcher.broadcast.title": "Broadcast",
  "shell.launcher.calendar.caption": "Schedule meetings with team and agents",
  "shell.launcher.calendar.title": "Calendar",
  "shell.launcher.chat.caption": "Team and agent conversations",
  "shell.launcher.chat.title": "Chat",
  "shell.launcher.data.caption": "Users, orgs, projects, plans",
  "shell.launcher.data.title": "Data",
  "shell.launcher.dragToHomeAria": "Drag to Home or press Alt+Enter to add it.",
  "shell.launcher.dragToHomeHint": "drag to Home or press Alt+Enter to add.",
  "shell.launcher.featureFlags.caption": "Toggle workspace features on and off",
  "shell.launcher.featureFlags.title": "Feature flags",
  "shell.launcher.files.caption": "Shared files and folders on the workspace desktop",
  "shell.launcher.files.title": "Files",
  "shell.launcher.following": "Following",
  "shell.launcher.followingTooltip": "Posts from people you follow",
  "shell.launcher.groupAdmin": "Admin",
  "shell.launcher.groupInsights": "Insights",
  "shell.launcher.groupTeam": "Team",
  "shell.launcher.groupViews": "Views",
  "shell.launcher.groupWork": "Work",
  "shell.launcher.heading": "Apps",
  "shell.launcher.mail.caption": "Workspace email and conversations",
  "shell.launcher.mail.title": "Mail",
  "shell.launcher.meet.caption": "Transcriptive meetings that apply edits on your workspace",
  "shell.launcher.meet.title": "Meet",
  "shell.launcher.moduleConsole.caption": "Assign + personalize the workspace module",
  "shell.launcher.moduleConsole.title": "Module console",
  "shell.launcher.newApp": "New app",
  "shell.launcher.newAppTooltip": "Create a new app",
  "shell.launcher.notes.caption": "Notes and the knowledge base",
  "shell.launcher.notes.title": "Notes",
  "shell.launcher.permissions.caption": "Roles, access and freebusy",
  "shell.launcher.permissions.title": "Permissions",
  "shell.launcher.reminders.caption": "Personal reminders and follow-ups",
  "shell.launcher.reminders.title": "Reminders",
  "shell.launcher.studio.caption": "Workspace apps and websites",
  "shell.launcher.systemHealth.caption": "Services, packages and uptime",
  "shell.launcher.systemHealth.title": "System Health",
  "shell.launcher.tasks.caption": "Tasks for humans and agents",
  "shell.launcher.tasks.title": "Tasks",
  "shell.launcher.teamAndAgents.caption": "Manage team and delegate responsibilities",
  "shell.launcher.teamAndAgents.title": "Team and agents",
  "shell.launcher.teamMembers.caption": "Your team and contributors directory",
  "shell.launcher.teamMembers.title": "Team members",
  "shell.launcher.teams.caption": "Team structure and membership",
  "shell.launcher.teams.title": "Teams",
  "shell.launcher.terminal.caption": "A command line in your browser",
  "shell.launcher.terminal.title": "Terminal",
  "shell.launcher.usage.caption": "Credits, metering and billing",
  "shell.launcher.usage.title": "Usage & billing",
  "shell.launcher.users.caption": "Meet, manage and reach your customers",
  "shell.launcher.users.title": "Users",
  "shell.launcher.workspaceUsage.caption": "Sessions, active users and usage across the whole workspace",
  "shell.launcher.workspaceUsage.title": "Workspace usage",
  "shell.launcherTileMenu.addToDashboard": "Add to dashboard",
  "shell.launcherTileMenu.alreadyOnHome": "Already on Home",
  "shell.launcherTileMenu.alreadyOnHomeBody": "This app is already on your dashboard.",
  "shell.launcherTileMenu.edit": "Edit",
  "shell.launcherTileMenu.notOnHome": "Not available on Home",
  "shell.launcherTileMenu.notOnHomeBody": "This app does not have a Home shortcut yet.",
  "shell.launcherTileMenu.open": "Open",
  "shell.launcherTileMenu.pin": "Pin to navbar",
  "shell.launcherTileMenu.sideView": "Open in side view",
  "shell.launcherTileMenu.unpin": "Unpin from navbar",
  "shell.messenger.loadFailed": "Couldn’t load chat. Check your connection and try again.",
  "shell.messenger.tooltip": "Direct messages",
  "shell.navSearchMenu.pin": "Pin to navbar",
  "shell.navSearchMenu.unpin": "Unpin",
  "shell.navbar.collapse": "Collapse navbar",
  "shell.navbar.expand": "Expand navbar",
  "shell.navbar.label": "Navbar: {position}",
  "shell.navbar.position.bottom": "bottom",
  "shell.navbar.position.left": "left",
  "shell.navbar.position.right": "right",
  "shell.navbar.position.top": "top",
  "shell.navbarTabMenu.remove": "Remove from navbar",
  "shell.navbarTabMenu.reset": "Reset navbar items",
  "shell.navbarTabMenu.sideView": "Open in side view",
  "shell.notificationBell.tooltip": "Notifications",
  "shell.notifications.close": "Close notifications",
  "shell.notifications.empty.all": "You're all caught up",
  "shell.notifications.empty.unread": "No unread notifications",
  "shell.notifications.empty.workspace": "Nothing from this workspace",
  "shell.notifications.markAllRead": "Mark all read",
  "shell.notifications.otherOrg.confirm": "Switch & open",
  "shell.notifications.otherOrg.message": "This notification lives in the \"{org}\" organization — opening it switches this tab there.",
  "shell.notifications.otherOrg.title": "Open in another organization?",
  "shell.notifications.panel.title": "Notifications",
  "shell.notifications.tab.all": "All",
  "shell.notifications.tab.unread": "Unread",
  "shell.notifications.tab.unreadCount": "Unread · {count}",
  "shell.notifications.tab.workspace": "Workspace",
  "shell.notifications.tab.workspaceTooltip": "Only notifications from the workspace you’re in",
  "shell.notifications.viewAll": "View all notifications",
  "shell.orgSwitcher.admin": "Admin",
  "shell.orgSwitcher.ariaDemo": "Demo organization",
  "shell.orgSwitcher.ariaForeign": "Viewing an external project — organization switcher unavailable",
  "shell.orgSwitcher.createFailed": "Create failed",
  "shell.orgSwitcher.createOrg": "+ Create organization",
  "shell.orgSwitcher.deleteConfirm": "Confirm delete?",
  "shell.orgSwitcher.deleteFailed": "Delete failed",
  "shell.orgSwitcher.deleteOrg": "Delete organization",
  "shell.orgSwitcher.deleting": "Deleting…",
  "shell.orgSwitcher.invite": "Invite members",
  "shell.orgSwitcher.networkError": "Couldn't reach the server — check your connection and try again.",
  "shell.orgSwitcher.newWorkspace": "New workspace",
  "shell.orgSwitcher.newWorkspaceAria": "Create a new workspace in this organization",
  "shell.orgSwitcher.newWorkspacePlaceholder": "e.g. Marketing",
  "shell.orgSwitcher.newWorkspacePrompt": "Name for the new workspace in {org}.",
  "shell.orgSwitcher.noWorkspaces": "No workspaces in this organization.",
  "shell.orgSwitcher.orgFallback": "this organization",
  "shell.orgSwitcher.orgLabel": "Organization",
  "shell.orgSwitcher.switchAria": "Switch organization",
  "shell.orgSwitcher.switchFailed": "Couldn't switch to {name}",
  "shell.orgSwitcher.workspaceFallback": "workspace",
  "shell.orgSwitcher.workspaceNotCreated": "Workspace not created",
  "shell.orgSwitcher.workspaces": "Workspaces",
  "shell.pageTitle.admin": "Admin",
  "shell.pageTitle.board": "Board",
  "shell.pageTitle.call": "Call",
  "shell.pageTitle.canvas": "Canvas",
  "shell.pageTitle.epics": "Epics",
  "shell.pageTitle.feed": "Feed",
  "shell.pageTitle.general": "General",
  "shell.pageTitle.inbox": "Inbox",
  "shell.pageTitle.myView": "My view",
  "shell.pageTitle.requests": "Requests",
  "shell.pageTitle.resolutions": "Resolutions",
  "shell.pageTitle.standups": "Standups",
  "shell.pageTitle.stories": "Stories",
  "shell.pageTitle.systemStatus": "System Status",
  "shell.pageTitle.transcript": "Transcript",
  "shell.searchBar.placeholder": "Search on Canvas",
  "shell.shortcuts.group.general": "General",
  "shell.shortcuts.group.goTo": "Go to",
  "shell.shortcuts.row.composer": "Write a prompt",
  "shell.shortcuts.row.escape": "Close, or stop customizing",
  "shell.shortcuts.row.nextWidget": "Next widget",
  "shell.shortcuts.row.openApp": "Open a dashboard app",
  "shell.shortcuts.row.openWidget": "Open the selected widget",
  "shell.shortcuts.row.prevWidget": "Previous widget",
  "shell.shortcuts.row.resizeWidget": "Resize the selected widget",
  "shell.shortcuts.row.sheet": "Keyboard shortcuts",
  "shell.shortcuts.row.widgetAction": "Run the selected widget’s action",
  "shell.shortcuts.then": "then",
  "shell.shortcuts.title": "Keyboard",
  "shell.theme.label": "Theme: {mode}",
  "shell.theme.mode.auto": "auto",
  "shell.theme.mode.dark": "dark",
  "shell.theme.mode.light": "light",
  "shell.viewNav.agents": "Agents",
  "shell.viewNav.workspaceApps": "Workspace apps",
  "shell.viewNav.websites": "Websites",
  "shell.viewNav.groupLabel": "VIEWS",
  "shell.viewNav.infra": "Infra",
  "shell.voice.agent.greeting": "Hi {name}, I’m Simone. How can I help?",
  "shell.voice.agent.greetingNoName": "Hi, I’m Simone. How can I help?",
  "shell.voice.backToTyping": "Back to typing",
  "shell.voice.call.commandTitle": "Voice command",
  "shell.voice.call.controls": "Call controls",
  "shell.voice.call.duration": "Call duration",
  "shell.voice.call.end": "End call",
  "shell.voice.call.endShort": "End",
  "shell.voice.call.listening": "Listening",
  "shell.voice.call.minimize": "Minimize — the call stays on",
  "shell.voice.call.mute": "Mute",
  "shell.voice.call.muted": "Muted",
  "shell.voice.call.speakNaturally": "Speak naturally — replies are read aloud.",
  "shell.voice.call.title": "Voice call",
  "shell.voice.call.transcript": "Call transcript",
  "shell.voice.call.type": "Type",
  "shell.voice.call.typeInstead": "Type a message — the call stays on",
  "shell.voice.engine.voice": "Voice",
  "shell.voice.engine.whyCommand": "Command mode — one-off: transcribed on the server, answered in the ElevenLabs voice.",
  "shell.voice.engine.whyTalk": "Talk with Simone — live conversation, spoken in the ElevenLabs voice.",
  "shell.voice.error.agentAllocation": "This workspace used its share of the organization's AI credits: a voice call cannot start.",
  "shell.voice.error.agentAllocationEnded": "The voice call ended: this workspace used its share of the organization's AI credits.",
  "shell.voice.error.agentBusy": "Too many calls in a short time — wait a few minutes, then try again.",
  "shell.voice.error.agentCreditsEnded": "The voice call ended: this workspace ran out of AI credits.",
  "shell.voice.error.agentDisconnected": "The ElevenLabs agent disconnected — retry to reconnect.",
  "shell.voice.error.agentNoCredits": "This workspace does not have enough AI credits for a voice call.",
  "shell.voice.error.agentSpendCap": "This workspace reached its AI spending limit: a voice call cannot start.",
  "shell.voice.error.agentSpendCapEnded": "The voice call ended: this workspace reached its AI spending limit.",
  "shell.voice.error.agentStartFailed": "The voice call could not start — try again.",
  "shell.voice.error.assistantOffline": "The assistant is offline on this surface — open it from the workspace shell to talk.",
  "shell.voice.error.micDenied": "Microphone access was denied — allow it in the address bar and try again.",
  "shell.voice.error.micOpenFailed": "Could not open the microphone.",
  "shell.voice.error.micUnsupported": "Microphone is unavailable in this browser.",
  "shell.voice.error.noSpeech": "Didn’t catch that — try again.",
  "shell.voice.error.notProvisioned": "Voice backend not provisioned",
  "shell.voice.error.recorderStartFailed": "Could not start the audio recorder.",
  "shell.voice.error.recorderUnsupported": "Audio recording is unavailable in this browser.",
  "shell.voice.error.transcribeFailed": "Transcription failed — try again.",
  "shell.voice.error.unavailableHere": "Voice is unavailable on this surface.",
  "shell.voice.expand": "Expand",
  "shell.voice.hint.command": "Try \"zoom to fit\", \"create a page called pricing\", or describe what to build.",
  "shell.voice.hint.talk": "Speak naturally — replies are read aloud. Esc minimizes the call.",
  "shell.voice.log.assistant": "Assistant",
  "shell.voice.log.done": "Done",
  "shell.voice.log.you": "You",
  "shell.voice.mic.mute": "Mute microphone",
  "shell.voice.mic.unmute": "Unmute microphone",
  "shell.voice.retry": "Try again",
  "shell.voice.status.connecting": "Connecting…",
  "shell.voice.status.done": "Done",
  "shell.voice.status.error": "Something went wrong.",
  "shell.voice.status.listening": "Listening…",
  "shell.voice.status.speaking": "Speaking…",
  "shell.voice.status.thinking": "Thinking…",
  "shell.voice.stopSpeaking": "Stop speaking",
  "shell.app.infra": "Infrastructure",
  "shell.launcher.infra.title": "Infrastructure",
  "shell.launcher.infra.caption": "Services, environments and deployments",
  "shell.overlay.brandHome": "Symbols home",
  "shell.invite.sub": "Send an email invite, or share a link that works once.",
  "shell.invite.subEmail": "Send an email invite at the role you choose.",
  "shell.invite.mode.label": "How to invite",
  "shell.invite.mode.email": "Email",
  "shell.invite.mode.link": "Magic link",
  "shell.invite.link.create": "Create and copy link",
  "shell.invite.link.ends": "Ends {date}",
  "shell.invite.link.singleUse": "Single use",
  "shell.invite.link.empty": "No open links. A link you create shows here.",
  "shell.invite.link.revokeAsk": "Revoke this link?",
  "shell.invite.link.keep": "Keep",
  "shell.invite.link.revokeConfirmLabel": "Confirm: revoke the {role} link that ends {date}",
  "shell.flyWorkspace.section": "Add section",
  "shell.flyWorkspace.remove": "Remove section",
  "shell.flyWorkspace.return": "Return to Fly",
  "shell.flyWorkspace.search": "Search workspace",
  "shell.flyWorkspace.sectionHint": "Add a live widget or a read-only view to this Fly page.",
  "shell.flyWorkspace.added": "Section added",
  "shell.flyWorkspace.emptySections": "This workspace has no available sections. Open a workspace page to use its full tools.",
  "shell.flyWorkspace.error.unavailable": "This item is no longer available. Choose another item.",
  "shell.flyWorkspace.error.limit": "This Fly page has reached its section limit. Remove a section before you add another.",
  "shell.flyWorkspace.error.duplicate": "This section is already on your Fly page.",
  "shell.flyWorkspace.error.navigation": "The page did not open. Try again.",
  "shell.flyWorkspace.error.changed": "The workspace changed. Open the picker again.",
  "shell.flyWorkspace.error.saving": "Wait for this page to save before you add a section.",
  "shell.flyWorkspace.localTitle": "My workspace",
  "shell.phoneNav.apps": "Apps",
  "shell.phoneNav.assistant": "AI",
  "shell.phoneNav.menu": "Menu",
  "shell.phoneNav.pageMenu": "Page menu",
  "shell.phoneNav.account": "Account and appearance",
  "shell.phoneNav.page": "Page",
  "shell.accountMenu.replayOnboarding": "Replay onboarding",
  "shell.phoneNav.appsTitle": "Your apps",
  "shell.phoneNav.appsHint": "Everything you need, one tap away.",
  "shell.phoneNav.menuTitle": "Your workspace",
  "shell.phoneNav.menuHint": "Search, switch spaces, and make it yours.",
  "shell.phoneNav.assistantAction": "Open or close AI assistant",
  "shell.viewNav.switchView": "Switch workspace view",
  "shell.launcher.categories": "App categories",
  "shell.launcher.allApps": "All apps",
  "shell.launcher.workspaceApps.caption": "Apps installed and built for this workspace"
}
